/**
 * To avoid confusion: The "Services" referred to in the file name are related to physical
 * services that Casper provides in a specific locale - not a 'code service' type of thing.
 */

export const localeMap = {
  'de-AT': {
    hasFinancing: false,
    hasWhiteGlove: true,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'de-CH': {
    hasFinancing: false,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'de-DE': {
    financingDuration: 6,
    hasFinancing: true,
    hasWhiteGlove: true,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'en-CA': {
    hasFinancing: true,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'en-GB': {
    hasFinancing: false,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'en-US': {
    hasFinancing: true,
    hasWhiteGlove: true,
    showMonthlyFinancing: false,
    showWhiteGloveModal: true,
  },
  'fr-CA': {
    hasFinancing: false,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'fr-CH': {
    hasFinancing: false,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
  'fr-FR': {
    financingDuration: 4,
    hasFinancing: true,
    hasWhiteGlove: true,
    showMonthlyFinancing: true,
    showWhiteGloveModal: false,
  },
  'nl-NL': {
    hasFinancing: false,
    hasWhiteGlove: false,
    showMonthlyFinancing: false,
    showWhiteGloveModal: false,
  },
};

class ServiceInfo {
  constructor(locale, options) {
    this.locale = locale;

    Object.assign(this, options);
  }
}

let financingInfo;

const buildFinancingInfo = (locale, options) => {
  if (!financingInfo || financingInfo.locale !== locale) {
    return new ServiceInfo(locale, options);
  }

  return financingInfo;
};

/**
 * Gets locale-specific service info.
 * @param {string} locale The locale key.
 * @returns {ServiceInfo} An object describing locale-specific servicing information.
 */
export const getServiceInfoForLocale = (locale) => {
  const financingOptions = localeMap[locale];

  return buildFinancingInfo(locale, financingOptions);
};

/**
 * Indicates whether financing is available for the specified locale.
 * @param {string} locale The locale key.
 * @returns {bool} true, if the locale has financing; otherwise false.
 */
export const hasFinancingInLocale = (locale) => {
  return getServiceInfoForLocale(locale).hasFinancing;
};
